var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.name === 'Project')?_c('div',[_c('div',[_vm._v("tools")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }